import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CfetBaseComponent } from '../../cfet-core';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-session-timeout-utf-modal',
    templateUrl: './session-timeout-utf-modal.component.html',
    styleUrls: ['./session-timeout-utf-modal.component.scss'],
    standalone: false
})
export class SessionTimeoutUtfModalComponent extends CfetBaseComponent implements OnInit {
  @Input() openModal: string;
  @Output() closeCancelModal = new EventEmitter<any>();
  url: any;
  fnStatus: any;

  constructor() {
    super();
  }

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit() {
    if (sessionStorage.getItem('fnStatus')) {
      this.fnStatus = sessionStorage.getItem('fnStatus');
    }
  }

  close(event: any, modalAction: string) {
    if (event.key === 'Enter' || event.type === 'click' ||
      event.keyCode === 13 || event.type === 'clicked outside') {
      this[modalAction] = 'close';
      this.closeCancelModal.emit('modalClose');
      if (sessionStorage.getItem('returnUrl') && Object.keys(sessionStorage.getItem('returnUrl').length !== 0)) {
        this.url = JSON.parse(sessionStorage.getItem('returnUrl'));
        if (this.url && this.url.indexOf('?') === -1) {
          this.redirectUrl(this.url + '?' + this.fnStatus);
        } else {
          this.redirectUrl(this.url + '&' + this.fnStatus);
        }
      } else {
        // Redirect to the plp page
        const url = environment.plp_page;
        this.redirectUrl(url + '&' + this.fnStatus);
      }
      window.scrollTo(0, 0);
      sessionStorage.clear();
    }
  }
  redirectUrl(url) {
    if (this.isEncoded(url)) {
      window.location.href = decodeURIComponent(url);
    } else {
      window.location.href = url;
    }
  }
  isEncoded(url) {
    if (url != '') {
      return url !== decodeURIComponent(url);
    }
  }

}
